<template>
  <div>
    <header>
      <h4>Let us help you to find your dream job!</h4>
    </header>

    <el-form @submit.native.prevent class="register-form">
      <el-form-item :required="true" :error="retrieveFieldError(modelState, 'emailAddress')">
        <el-input placeholder="Email / Username"></el-input>
      </el-form-item>

      <el-form-item :required="true" :error="retrieveFieldError(modelState, 'password')" class="password">
        <el-input placeholder="Password" type="password" show-password></el-input>
      </el-form-item>

      <button
        class="ts-btn ts-btn-rounded ts-btn-secondary ts-btn-full"
        :class="{ loading: isLoading }"
      >
        <i><v-icon name="circle-notch" /></i> Log In
      </button>
      <div style="margin-top: 10px; text-align: center">
        <p style="margin-bottom: 0" class="secondary-p">
          Don't have an account?&nbsp;Create one
          <a href="/apprentice-register">here</a>
        </p>
        <p class="secondary-p">
          Forgot Password? Click <a href="/forgot-password">here</a>
        </p>
      </div>
    </el-form>
    <!-- <loading 
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="false">
    </loading> -->

    <TSLoading
      :active="isLoading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process the data...'"
    />
  </div>
</template>

<script>
import TSLoading from "../../../components/TSLoading.vue";
import loginUtils from "@/utils/login.utils";

export default {
  components: {
    TSLoading,
  },
  async created() {
    this.setStorageData();
  },
  data() {
    return {
      isLoading: false,
      modelState: {},
      currentlyLoggedInUserId: "",
      connection: {},
      huburl: process.env.VUE_APP_MESSAGE_BASE_URI,
    };
  },
  methods: {
    setStorageData() {
      this.isLoading = true;

      const { apprenticeId, token } = this.$route.params;

      localStorage.setItem("debugid", apprenticeId);
      localStorage.setItem("token", token);
      localStorage.setItem("fromSuperAdmin", "true");

      const timeOutTime = new Date().getTime() + (loginUtils.getSessionTimeoutInMilliseconds());
      localStorage.setItem('timeOutTime', timeOutTime);

      this.$store
        .dispatch("account/getUserInfo")
        .then(() => {
          this.$router.push({ name: "apprentice-login" });
        })
        .finally(() => { this.isLoading = false; });
    },
    getCurrentlyLoggedIn() {
      let loggedInUserId = "";
      var base64Url = localStorage.getItem("token").split(".")[1];
      var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      var jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );
      var data = JSON.parse(jsonPayload);

      if (
        data[
          "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
        ] != ""
      ) {
        loggedInUserId =
          data[
            "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
          ];
      }

      return loggedInUserId;
    }
  },
};
</script>

<style scoped>
.forlink {
  float: left;
}
</style>
